/**
 * @copyright 2025 @ DigiNet
 * @author ANHTAI
 * @create 06/08/2025
 * @update 06/08/2025
 * @file src/components/W06/W06F2520
 */

import * as types from '../actions/types.js';

const initialState = {
    decimalSetting: {},
};

export default function (state = initialState, action = {}) {
    switch (action.type) {
        case types.W06_W06F2520_LOAD_DECIMAL_SETTING_COMPLETE:
            return {
                ...state,
                decimalSetting: action.data
            };
        default:
            return state;
    }
}